/* eslint-disable no-unused-vars */
import ImageIcon from '@mui/icons-material/Image';
import {
  Box,
  Card,
  CardHeader,
  Divider,
  Grid,
  Typography
} from '@mui/material';
import React from 'react';

export default function PackageDetailsMediaTab({
  imageList = [],
  videoList = [],
  onImageClick
}) {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          <ImageIcon sx={{ mr: 1 }} />
          Media Content
        </Typography>
        <Divider sx={{ mb: 2 }} />
      </Grid>

      {/* Image Gallery */}
      {imageList?.length > 0 && (
        <>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Images ({imageList.length})
            </Typography>
          </Grid>
          {imageList.map((img, i) => (
            <Grid item key={i} xs={2}>
              <Card
                sx={{
                  borderRadius: 2,
                  boxShadow: 3,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  transition: 'transform 0.2s',
                  '&:hover': { transform: 'scale(1.01)' }
                }}
                onClick={() => onImageClick(img)}
              >
                <CardHeader title={`Image ${i + 1}`} />
                <Box>
                  <img
                    src={img}
                    alt={`#${i + 1}`}
                    style={{
                      width: '100%',
                      height: '300px',
                      objectFit: 'contain',
                      display: 'block'
                    }}
                  />
                </Box>
              </Card>
            </Grid>
          ))}
        </>
      )}

      {/* Video Gallery */}
      {videoList?.length > 0 && (
        <>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Videos ({videoList.length})
            </Typography>
          </Grid>
          {videoList.map((video, i) => (
            <Grid item key={i} xs={2}>
              <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
                <CardHeader title={`Video ${i + 1}`} />
                <Box sx={{ width: '100%' }}>
                  <video
                    controls
                    src={video}
                    style={{
                      width: '100%',
                      height: 'auto',
                      borderBottomLeftRadius: 8,
                      borderBottomRightRadius: 8
                    }}
                  >
                    Your browser does not support the video tag.
                  </video>
                </Box>
              </Card>
            </Grid>
          ))}
        </>
      )}
    </Grid>
  );
}
